export default {
      id: "questionmark-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons-sprite.626747e.svg#questionmark-usage",
      toString: function () {
        return this.url;
      }
    }